import api from '../config/axios';

export const uploadDocuments = (studentId, category, files, slotName = null) => {
  const formData = new FormData();
  formData.append('category', category);
  if (slotName) formData.append('slotName', slotName);
  files.forEach((file) => formData.append('files', file));
  return api.post(`/documents/${studentId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getDocuments = (studentId) => api.get(`/documents/${studentId}`);
export const getDocumentsByCategory = (studentId, category) =>
  api.get(`/documents/${studentId}/category/${category}`);
export const downloadDocument = (docId) =>
  api.get(`/documents/${docId}/download`, { responseType: 'blob' });
export const viewDocument = (docId) =>
  api.get(`/documents/${docId}/view`, { responseType: 'blob' });
export const deleteDocument = (docId) => api.delete(`/documents/${docId}`);
export const getVersionHistory = (docId) => api.get(`/documents/${docId}/versions`);
export const mergeCategory = (studentId, category) =>
  api.post(`/documents/${studentId}/merge/${category}`);
export const mergeAll = (studentId) => api.post(`/documents/${studentId}/merge-all`);
export const requestDocument = (studentId, documentName, message = '', category = 'extra_documents') =>
  api.post(`/documents/${studentId}/request`, { documentName, message, category });
export const getDocumentRequests = (studentId) => api.get(`/documents/${studentId}/requests`);

export const uploadCompleteCategoryPdf = (studentId, category, file) => {
  const formData = new FormData();
  formData.append('files', file);
  return api.post(`/documents/${studentId}/upload-complete-pdf/${category}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const uploadSanctionLetter = (studentId, file) => {
  const formData = new FormData();
  formData.append('files', file);
  return api.post(`/documents/${studentId}/sanction-letter`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
